export class ClaimsTypes {
    static readonly BelongsToGroup = "bbwt.claims.belongs_to_group";
    static readonly TenantId = "https://schemas.microsoft.com/identity/claims/tenantid";
    static readonly HashedTenantId = "https://schemas.microsoft.com/identity/claims/tenantid#hashed";
    static readonly NameIdentifier = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
    static readonly EmailAddress = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
    static readonly Role = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
    static readonly UserPermission = "bbwt.claims.authentication.user_permission";
    static readonly MiProEnabledModule = "mipro.claims.enabled_module";
    static readonly UserFullname = "mipro.claims.user_full_name";
    static readonly AllTenantIds = "mipro.claims.tenant.all_tenant_ids";
    static readonly OrganisationSystemCode = "mipro.claims.organization_system_code";
    static readonly SelfDirectedGymRecoveryPermission = "mipro.claims.tenant.permission_self_directed_gym_recovery";
    static readonly TenantGoverningBodyId = "mipro.claims.tenant.governing_body_id";
    static readonly HashedTenantGoverningBodyId = "mipro.claims.tenant.governing_body_id#hashed";
    static readonly HomeDashboardToggleEnabled = "mipro.claims.home_dashboard_toggle_enabled";
    static readonly DefaultHomeScreenMode = "mipro.claims.tenant.default_home_screen_mode";
    static readonly LoginType = "mipro.claims.login_type";
    static readonly RealPersonId = "mipro.claims.real_person_id";
}
